import { render, staticRenderFns } from "./tab15.vue?vue&type=template&id=f1a90260&scoped=true&"
import script from "./tab15.vue?vue&type=script&lang=js&"
export * from "./tab15.vue?vue&type=script&lang=js&"
import style0 from "./tab15.vue?vue&type=style&index=0&id=f1a90260&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1a90260",
  null
  
)

export default component.exports